/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
export default {
  getOrders (state) {
    return state.list
  },
  getOrder (state) {
    return state.currentOrder
  },
  getProduct (state) {
    // let response = []
    if (state.currentOrder && state.currentOrder.items && state.currentOrder.items.length) {
      let items = state.currentOrder.items
      let objTmp = {}
      let arrTmp = []
      items.forEach((item, index) => {
        if (!item.parent_item_id) {
          objTmp = { ...item }
          objTmp.children = []
          arrTmp.push(objTmp)
        } else {
          if (item.parent_item_id === objTmp.item_id) {
            objTmp.children.push(item)
            objTmp.product_id = item.product_id
            objTmp.sku = item.sku
          }
        }
      })
      return arrTmp
    }
  },
  totalSegments (state) {
    let totals = []
    if (state.currentOrder && state.currentOrder.extension_attributes && state.currentOrder.extension_attributes.totals_segment) {
      totals = state.currentOrder.extension_attributes.totals_segment
    }
    return totals
  }
}
